import Vue from 'vue';
import { GlobalState, store } from '../global-state/global-state';
import { isMobile, isSliderMenu, getScrollbarWidthPresent } from "../utils/helpers";

export default () => {
  // Close Account Modal
  // Clicking the Body
  // ===================
  $(document).click(function (event) {
    let clickedElement = $(event.target);
    let accountIconButton = '.new-layout-header__actions-account';
    let modal = '[data-account-modal]';
    if (
      !clickedElement.closest(accountIconButton).length &&
      !clickedElement.closest(modal).length &&
      $(modal).css('visibility') === 'visible'
    ) {
      $('[data-account-modal]').removeClass('active');
    }
  });

  // Vue JS Component
  // ===================

  new Vue({
    el: '#shopify-section-header',
    data: {
      sharedState: GlobalState.state,
    },
    mounted() {
      this.megaMenuDropdown();
      window.addEventListener('resize', this.megaMenuDropdown);
      let $vm = this;

      // Trigger Search Button to be Active
      $('.search-bar__search-input').on('focus', function () {
        let searchBarInputValue = $(this).val().length;
        $(this).closest('form').addClass('form--focused');
        $vm.searchBarActions(searchBarInputValue);
      });
      $('.search-bar__search-input').on('blur', function () {
        let searchBarInputValue = $(this).val().length;
        $(this).closest('form').removeClass('form--focused');
        $vm.searchBarActions(searchBarInputValue);
      });

      $('.search-bar__search-input').on('keypress', function () {
        let searchBarInputValue = $(this).val().length;
        $vm.searchBarActions(searchBarInputValue);
      });

      // Clear Search Text
      $('.search-bar__clear-text').on('click', () => {
        $('.search-bar__search-input').val('');
      });
    },
    methods: {
      toggleAccountModal: function (event) {
        let clickedElement = $(event.target);
        let modal = '[data-account-modal]';

        if (!clickedElement.closest(modal).length) {
          $('[data-account-modal]').toggleClass('active');
        }
      },
      closeMobileAccountModal: function (event) {
        if (isSliderMenu()) {
          $('#mobile-account-modal').removeClass('active');
        }
      },
      toggleSearchBar: function () {
        $('section.search-bar').toggleClass('active');
        $('.new-layout-header__nav').toggleClass('search-active');
        $('.new-layout-header__actions').toggleClass('search-active');
      },
      megaMenuDropdown: function () {
        if (!isMobile()) {
          $(window).on('scroll', function (e) {
            if (window.scrollY >= 40) {
              $('body').addClass('scrolled');
            } else {
              $('body').removeClass('scrolled');
            }
          });
        }

        if (!isSliderMenu()) {
          // Transparent Nav Bar is only on the Home Page
          if ($('.template-index').length) {
            $('#new-layout-header').on('mouseenter', function () {
              $('.new-layout-header').addClass('solid-background');
            });
            $('#new-layout-header').on('mouseleave', function () {
              $('.new-layout-header').removeClass('solid-background');
            });
          }

          // get scrollbar width for padding
          const bodyPaddingRight = getScrollbarWidthPresent || 0 + 'px';

          $('.new-layout-header__items').on('mouseleave', function () {
            $('body').removeClass('scroll-locked');
            $('.dropdown-content').addClass('fade-in-dropdown');
          });
          $('.dropdown').on('mouseenter', function () {
            $('body').addClass('scroll-locked');
            $('body').css('padding-right', bodyPaddingRight);
            $('.new-layout-header').css('padding-right', bodyPaddingRight);
            $('.dropdown').removeClass('active-menu');
            $(this).addClass('active-menu');
            $(this).find('.sectionOne > div').css('opacity', '1');
            $(this).find('.sectionTwo > div').css('opacity', '1');

            setTimeout(() => {
              $('.dropdown-content').removeClass('fade-in-dropdown');
            }, 350);
          });

          $('.dropdown').on('mouseleave', function () {
            $('body').removeClass('scroll-locked');
            $('body').css('padding-right', 0);
            $('.new-layout-header').css('padding-right', 0);
            $('.dropdown').removeClass('active-menu');
            $('.sectionOne > div').css('opacity', '0');
            $('.sectionTwo > div').css('opacity', '0');
          });
        } else {
          // Unbind the Hover & Scroll Events
          $('.dropdown').off('mouseenter');
          $('.dropdown').off('mouseleave');
          $('.new-layout-header__items').off('mouseleave');
          // Fade In Section One and Two Content
          $('.sectionOne > div').css('opacity', '1');
          $('.sectionTwo > div').css('opacity', '1');
        }
      },
      searchBarActions: function (value) {
        if (value > 2) {
          $('.search-bar__search-resting').addClass('hidden');
          $('.search-bar__search-button')
            .addClass('active')
            .prop('disabled', false);
          $('.search-bar__clear-text').removeClass('hidden');
        } else {
          $('.search-bar__search-resting').removeClass('hidden');
          $('.search-bar__search-button')
            .removeClass('active')
            .prop('disabled', true);
          $('.search-bar__clear-text').addClass('hidden');
        }
      },
    },
    computed: {
      checkValue() {
        return store.count > 0 ? true : false;
      },
      count() {
        return store.count;
      },
    },
  });
};
